module.exports = vendor_2d82654;